import React from 'react';
import { Col } from 'react-bootstrap';
import CustomCheckBox from '../../CustomCheckBox';

const AttributeCheckBox = (props) => {
  const { attributeStates, finalAttributeList, onCheckBoxChangeHandler } =
    props;

  return finalAttributeList?.map((attribute) => (
    <Col md={12} key={attribute?.label}>
      <CustomCheckBox
        name={attribute?.label}
        label={attribute?.label}
        className={`check-box h-28`}
        classNameLabel={`font-size-14 w-200`}
        onChange={() => onCheckBoxChangeHandler(attribute)}
        checked={
          !!attributeStates?.find(
            (item) => item?.attribute?.label === attribute?.label
          )
        }
      />
    </Col>
  ));
};

export default AttributeCheckBox;
